import styled from 'styled-components';

export const FooterContainer = styled.div`
    padding: 2.5rem;
    background: #000000;
    color: white;
    font-size: 1rem;
    font-weight: 50;
    letter-spacing: 0.01rem;
`;

export const FooterCopyright = styled.div`
    text-align: center;
`;